import React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { logEvent } from "firebase/analytics";
import { analytics } from "../../App/Analytics";

import { FetchUserFromUserHandleV2 } from "../../graphql/customWebappQueries/userProfileQueries";
import {
  UserProfileHeader,
  UserProfileHeaderConfig,
} from "./UserProfileHeader";
import {
  FetchUserFromUserHandleQuery,
  FetchUserFromUserHandleQueryVariables,
} from "../../API";
import {
  LoadingView,
  ErrorView,
  CenteringView,
} from "../../Components/RecurringSmallViews/RecurringSmallViews";

import {
  UserProfileTabSwitcher,
  UserProfileTabSwitcherConfig,
} from "./UserProfileTabSwitcher";

function _UserProfileLoading(): JSX.Element {
  const { userHandle } = useParams();

  logEvent(analytics, "screen_view", {
    firebase_screen: "UserProfileLoading",
    firebase_screen_class: "UserProfileLoading",
    user_handle: userHandle,
  });

  if (!userHandle) {
    return ErrorView();
  }

  const { loading, error, data } = useQuery<
    FetchUserFromUserHandleQuery,
    FetchUserFromUserHandleQueryVariables
  >(FetchUserFromUserHandleV2, {
    errorPolicy: "ignore",
    variables: {
      userHandleStandardForm: userHandle.toLowerCase(),
    },
  });

  if (loading) {
    return LoadingView();
  }
  if (error) {
    return ErrorView();
  }

  const fetchedUser = data?.getUserHandle?.owner;
  if (fetchedUser) {
    const headerConfig: UserProfileHeaderConfig = {
      userHandleRenderedForm: fetchedUser.userHandle?.renderedForm ?? "Unknown",
      userBio: fetchedUser.bio ?? "",
      userName: fetchedUser.name ?? "Unknown",
      profilePicId: fetchedUser.profilePhoto.publicId,
      followersCount: 42,
      followingCount: 44,
      // primaryPost: makeNonRecursivePostCardConfig(
      //   fetchedPost,
      //   primaryPostPreExpandedAndAutoplaying
      // ),
      // primaryPostFootnote: makeFootnoteConfig(fetchedPost),
    };

    const tabSwitcherConfig: UserProfileTabSwitcherConfig = {
      userSub: fetchedUser.sub,
    };

    return (
      <div>
        <UserProfileHeader {...headerConfig} />

        <UserProfileTabSwitcher {...tabSwitcherConfig} />
      </div>
    );
  }

  return ErrorView("Unexpected.");
}

function UserProfileLoading(): JSX.Element {
  return CenteringView(_UserProfileLoading());
}

export default UserProfileLoading;
